import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosAsync, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormCaja05  extends React.Component{
    constructor(props){
        super(props);
        this.state = {

            fechaDesde: null,
            fechaHasta: null,

            caja_sel: null,
            caja_opt: [],
            tipo_sel: null,
            tipo_opt: [],
            cliente_sel: null,
            
        };
        //OP OVERCONTROLLS
        this.changeComponents = this.changeComponents.bind(this);
        //this.changeYear = this.changeYear.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impMovimientosCaja = this.impMovimientosCaja.bind(this);
    }

    changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
          }
    }
    
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getOptions_Articulos(input, callback){
        if (input.toString().length >= 2 ){
            let query = "?tipo=catalogo&cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/articulos', query, callback)
        }
    }

    getOptions_Marcas(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('LINEA', input, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    componentDidMount(){
        Promise.all([
            cargarCatalogos_Otros('CAJA-CTAS'),
            cargarCatalogos_Otros('TIPO-CAJOP'),
            this.props.generar_LogAuditoriaIngresoForm('0505')
         ])
        .then(([ caja, cajaOp ]) => {

            //Asignacion de Fecha
            let fechaProceso = getFechaProcesoPorModulo('05');

            let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
            let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
            this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta,
            caja_opt: caja, tipo_opt: cajaOp})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0505');
    }

    validacionFechaTrabajo(fechaProceso, fecha){
        
        var respuesta;
        var i_fecha = formatearFechaMoment_a_String(fecha)
        let fechaPartProceso = fechaProceso.split('/');
        let fechaPart = i_fecha.split('/');

        //Evaluacion Año
        if(fechaPart[2]===fechaPartProceso[2]){
            respuesta = true;
        }else{
            respuesta = false;
        }

        return respuesta;
    }

    limpiar(){
        //Asignacion de Fecha
        let fechaProceso = getFechaProcesoPorModulo('05');

        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})

        this.setState({
            caja_sel: null,
            tipo_sel: null,
            cliente_sel: null,
        })
    }

    impMovimientosCaja(){
        var continuar = true;
        var error = "";
        var errorAnio = false;
        let fechaProceso = getFechaProcesoPorModulo('05');

        if(this.validacionFechaTrabajo(fechaProceso, this.state.fechaHasta)===false){
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha hasta no esta dentro del año vigente.\n';
        }

        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
        }

        if(continuar === true){
            var parametros = ""
            parametros = '&rpt=40&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)

            if(this.state.caja_sel!==null){
                parametros = parametros+'&param3='+this.state.caja_sel
            }


            if(this.state.tipo_sel!==null){
                parametros = parametros+'&param4='+this.state.tipo_sel
            }

            if(this.state.cliente_sel!==null){
                parametros = parametros+'&param5='+this.state.cliente_sel.value
            }

            if(this.state.vendedor_sel){
                parametros = parametros+'&param6='+this.state.vendedor_sel.value
            }

            visualizarReporteEnPdf(parametros);
        }else{
            alert(error);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Movimientos Caja</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-8 '>{/*col-sm-offset-4 col-sm-pull-4 - col-sm-offset-4 col-sm-pull-4*/}
                        <Row>
                            <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='8'>
                                <LabelForm>Desde:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-5 ' margen_arriba='15' margen_abajo='4'>
                                <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-2' margen_abajo='4'>
                                <LabelForm>Hasta:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-5 col-sm-push-1' margen_abajo='4'>
                                <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                            </ContainerCol>
                        </Row>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>  
                            <Row>
                                <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='4'>
                                    <LabelForm>Caja:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-6 col-sm-offset-3 col-sm-pull-3' margen_arriba='15' margen_abajo='4'>
                                    <ReactSelect options={ this.state.caja_opt } value={this.state.caja_sel} func_onChange={(value)=>{this.setState({caja_sel: value!==null?value.value:null})}}/>
                                </ContainerCol>
                            </Row>                          
                            <Row>
                                <ContainerCol className='col-sm-3' margen_abajo='4'>
                                    <LabelForm>Tipo:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-8 col-sm-offset-1 col-sm-pull-1' margen_abajo='4'>
                                    <ReactSelect options={ this.state.tipo_opt } value={this.state.tipo_sel} func_onChange={(value)=>{this.setState({tipo_sel: value!==null?value.value:null})}}/>
                                </ContainerCol>
                            </Row> 
                            <Row>
                                <ContainerCol className='col-sm-3' margen_abajo='4'>
                                    <LabelForm>Cliente:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-8' margen_abajo='4'>
                                    <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value!==null?value:null})}}/>
                                </ContainerCol>
                            </Row>    
                            <Row>
                                <ContainerCol className='col-sm-3' margen_abajo='4'>
                                    <LabelForm>Vendedor:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-8' margen_abajo='4'>
                                    <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} func_onChange={(value)=>{this.setState({vendedor_sel: value!==null?value:null})}}/>
                                </ContainerCol>
                            </Row>                                               
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={this.impMovimientosCaja}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario
    }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCaja05);